import React, { useState, useEffect, Fragment, useRef, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import { v4 } from 'uuid';

var createSharedContext = function createSharedContext(Root, isAsync) {
  if (Root === void 0) {
    Root = Fragment;
  }

  if (isAsync === void 0) {
    isAsync = true;
  }

  var renderWithSharedContext;

  var SharedContext = function SharedContext(rootProps) {
    var _useState = useState([]),
        components = _useState[0],
        setComponents = _useState[1];

    useEffect(function () {
      renderWithSharedContext = function renderWithSharedContext(component) {
        setComponents(function (prevState) {
          prevState.push(component);
          return [].concat(prevState);
        });
        return {
          update: function update(props) {
            setComponents(function (prevState) {
              var prevComponent = prevState.find(function (c) {
                return (c === null || c === void 0 ? void 0 : c.key) === component.key;
              });

              if (!prevComponent) {
                return prevState;
              }

              prevComponent.props = props;
              return [].concat(prevState);
            });
          },
          remove: function remove() {
            setComponents(function (prevState) {
              var index = prevState.findIndex(function (c) {
                return (c === null || c === void 0 ? void 0 : c.key) === component.key;
              });

              if (index === -1) {
                return prevState;
              }

              prevState[index] = undefined;
              return [].concat(prevState);
            });
          }
        };
      };
    }, []);
    return React.createElement(Root, Object.assign({}, rootProps), components.map(function (component) {
      if (!component) {
        return null;
      }

      var key = component.key,
          node = component.node,
          C = component.component,
          props = component.props;
      return createPortal(React.createElement(C, Object.assign({
        key: key
      }, props)), node);
    }));
  };

  var useSharedContext = function useSharedContext(component) {
    var UseSharedContext = function UseSharedContext(props) {
      var key = useRef(v4());
      var ref = useRef(null);
      var instance = useRef();
      (isAsync ? useEffect : useLayoutEffect)(function () {
        if (instance.current) {
          instance.current.update(props);
        }
      }, [props]);
      (isAsync ? useEffect : useLayoutEffect)(function () {
        if (ref.current && ref.current.parentElement) {
          instance.current = renderWithSharedContext({
            key: key.current,
            node: ref.current.parentElement,
            component: component,
            props: props
          });
          return instance.current.remove;
        }

        return;
      }, []);
      return React.createElement("div", {
        ref: ref,
        style: {
          display: 'none'
        }
      });
    };

    return UseSharedContext;
  };

  return {
    component: SharedContext,
    use: useSharedContext
  };
};

export default createSharedContext;
//# sourceMappingURL=index.modern.js.map
